import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_CRIMSON } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/cradles-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/cradles-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/cradles-extreme.guitar.json' with { type: 'json' };

export const CRADLES_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'cradles',
  baseTitle: "Why We Lose",
  description: "Cartoon's Why We Lose on DatZTactix's cut-length mania set. Melancholic DnB groove — three diffs ramp from sparse Easy to denser Hard streams.",
  difficulty: 5,
  palette: PALETTE_CRIMSON,
  audioSrc: '/audio/guitar/cradles.mp3',
  attribution: "\"Why We Lose\" by Cartoon (feat. Coleman Trapp) [NCS Release] - https://ncs.io/whywelose",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
